import { Box, ScrollView, RenderHtml } from '@betty/moonlight';
import { Page, SplashScreen } from '@betty/navigation';
import { useCallback, useEffect, useState } from 'react';
import { TermsAndConditionsService } from '@betty/toolkit/services';
import { logError } from '@betty/toolkit/logging';

function TermsPage() {
  const [termsAndConditionsContent, setTermsAndConditionsContent] =
    useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchTermsAndConditionsContent = useCallback(async () => {
    setIsLoading(true);
    try {
      const { content } =
        await TermsAndConditionsService.getTermsAndConditions();
      setTermsAndConditionsContent(content);
    } catch (error) {
      logError('Error fetching terms and conditions', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTermsAndConditionsContent();
  }, [fetchTermsAndConditionsContent]);

  if (isLoading) {
    return <SplashScreen />;
  }
  return (
    <Page
      titleKey="Betty.ca - Terms and Conditions"
      descriptionKey="If you are using or intending to play on Betty, You do so in accordance with these Terms of Service."
    >
      <ScrollView showsHorizontalScrollIndicator={false}>
        <Box centerContent>
          <Box
            width={{
              desktop: '50%',
              tablet: '70%',
              mobile: '100%',
            }}
            alignItems="center"
            paddingHorizontal="space-400"
          >
            <RenderHtml html={termsAndConditionsContent} variant="body-m" />
          </Box>
        </Box>
      </ScrollView>
    </Page>
  );
}

export default TermsPage;
